import { httpsCallable } from "firebase/functions";
import { functions } from "../../../config/firebase-config";
import { notifyPermissionDenied } from "../handleCallableError";

export const createAdmin = async (
  dealershipId,
  email,
  name,
  personalId,
  password = null,
  operatingUnitId = null,
) => {
  if (!email || !dealershipId || !name || !personalId) {
    return { success: "no", message: "Faltan campos obligatorios" };
  }

  try {
    const createAdminFn = httpsCallable(functions, "createAdminV2");
    const initialPassword = typeof password === "string" ? password.trim() : "";
    const result = await createAdminFn({
      dealershipId,
      email,
      name,
      personalId,
      requestedApp: "group_web",
      ...(operatingUnitId ? { operatingUnitId } : {}),
      ...(initialPassword ? { password: initialPassword } : {}),
    });
    const response = result.data;
    const message = response?.otherRole
      ? `Administrador creado. La persona ya existía como ${response.otherRole.role} (${response.otherRole.email}). Se creó una cuenta separada de miembro.`
      : response?.message || "Administrador creado con éxito";
    return { ...response, message };
  } catch (error) {
    console.error("Error creando admin:", error);
    notifyPermissionDenied(error);
    return {
      success: "no",
      message: "Error al crear el administrador",
      error: error.message,
    };
  }
};
